import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Button, Icon, LinkButton, errorMessage, isApiError } from '@saas/ui';

/** ルートの例外（遅延ロードの失敗・描画エラー）。原因 + 再試行（C-12） */
export function RouteErrorPage() {
  const error = useRouteError();
  const isChunk = error instanceof Error && /Failed to fetch dynamically imported module|Importing a module script failed/i.test(error.message);
  const title = isRouteErrorResponse(error) && error.status === 404 ? 'ページが見つかりません' : isChunk ? 'アプリの新しい版があります' : isApiError(error) && error.isForbidden ? 'この画面を表示する権限がありません' : '画面を表示できませんでした';
  const detail = isChunk ? '再読み込みすると最新の画面が開きます。' : isRouteErrorResponse(error) ? error.statusText : errorMessage(error, '予期しないエラーが発生しました');
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-2 px-5 py-16 text-center" role="alert">
      <Icon name="error" size={28} className="text-danger" />
      <h1 className="font-serif text-title">{title}</h1>
      <p className="max-w-md text-callout text-fg-secondary">{detail}</p>
      <div className="mt-4 flex gap-2">
        <Button variant="primary" icon="refresh" onClick={() => window.location.reload()}>
          再読み込み
        </Button>
        <LinkButton to="/" variant="secondary" reloadDocument>
          自分宛てへ戻る
        </LinkButton>
      </div>
    </div>
  );
}
